import React from 'react'
import { GoogleLogoStyle } from '../styles/GoogleLogo.styled';

const GoogleLogo = () => {
    return (
        <GoogleLogoStyle>
            <img className="google-logo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/552px-Google_2015_logo.svg.png" alt=""/>
        </GoogleLogoStyle>
    )
}

export default GoogleLogo